export default __webpack_public_path__ + "static/Montserrat-Regular-0dea8d0860451ddab7d413ab6bce1966.woff";